<!--电缆cableWell-->
<template>
  <div class="cableWell" @click.stop="flag = false">
    <div class="box">
      <div class="li" v-for="(e,i) in list" :key="i" @click.stop="detail($event,e)">
        <img src="./shexiangtou.jpg" alt="">
        <div class="gai" :class="{'red':e.gai}"></div>
        <div class="content">
          <div class="huang">
            <div class="top" :class="{'red':e.gaoshuiwei}">
              <div class="lan"></div>
              <div class="lan"></div>
            </div>
            <!-- 温度 -->
            <div :class="e.temp1>=70?'hong':'lv'"></div>
            <div :class="e.temp2>=70?'hong':'lv'"></div>
            <div :class="e.temp3>=70?'hong':'lv'"></div>
            <div :class="e.temp4>=70?'hong':'lv'"></div>
            <div :class="e.temp5>=70?'hong':'lv'"></div>
            <div :class="e.temp6>=70?'hong':'lv'"></div>

            <div class="laned" :class="{'red':e.dishuiwei}">
              <div class="lan"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form" v-if="flag" :style="getDataStyle" @click.stop="flag = true">
      <div class="li">设备编号：{{form.devid}}</div>
      <div class="li">设备地址：{{form.deviceAddress}} </div>
      <div class="li" style="display: flex;">设备图： <el-image style="width: 50px; height: 50px" :src="form.pictureContent"
          :preview-src-list="[form.pictureContent]">
        </el-image></div>
      <div class="li">标签：{{form.tags}}</div>
      <div class="li">温度1：{{form.temp1}}</div>
      <div class="li">温度2：{{form.temp2}}</div>
      <div class="li">温度3：{{form.temp3}}</div>
      <div class="li">温度4：{{form.temp4}}</div>
      <div class="li">温度5：{{form.temp5}}</div>
      <div class="li">温度6：{{form.temp6}}</div>
      <div class="btns">
        <div class="success" @click.stop="edit(form)">设备编辑</div>
        <div class="success" @click.stop="dialogVisible2 = true">设备历史</div>
      </div>
    </div>

    <el-dialog title="编辑地址" v-dialogDrag :visible.sync="dialogVisible" width="400" center>
      <el-form :model="temp" :rules="rules" ref="temp" label-width="120px" class="demo-temp">
        <el-form-item label="地址" prop="deviceAddress">
          <el-input v-model="temp.deviceAddress" placeholder="请输入地址"></el-input>
        </el-form-item>

      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="edit_fn('temp')">确 定
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog title="搜索历史" v-dialogDrag :visible.sync="dialogVisible2" width="300" center>
      <el-form ref="temp" label-width="120px" class="demo-temp">
        <el-form-item label="日期">
          <el-date-picker v-model="value1" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="search">搜 索
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog title="搜索历史" v-dialogDrag :visible.sync="dialogVisible3" width="400" center>
      <el-table
        :header-cell-style="{ color: '#333', fontFamily: 'MicrosoftYaHeiUI', fontSize: '14px', fontWeight: 900, backgroundColor: '#f5f7fa'}"
        stripe :data="tableData" border style="width: 100%">
        <template slot="empty">
          <span class="noData">
            <img src="../../assets/noData.png" alt="暂无数据">
            <span class="text">暂无数据</span>
          </span>
        </template>
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bat1" label="温度1" />
        <el-table-column prop="bat2" label="温度2" />
        <el-table-column prop="co2" label="co2" />
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | parseTime('{y}-{m}-{d} {h}:{i}:{s}')}}</span>
          </template>
        </el-table-column>

        <el-table-column label="设备图" width="120">
          <template slot-scope="scope">
            <el-image style="width: 50px; height: 50px" :src="scope.row.pictureContent"
              :preview-src-list="[scope.row.pictureContent]">
            </el-image>
          </template>
        </el-table-column>

        <el-table-column prop="deviceAddress" label="设备地址" width="140" />
        <!-- <el-table-column prop="devid" label="devid" /> -->
        <el-table-column prop="hs2" label="hs2" />
        <el-table-column prop="io" label="io" />
        <!-- <el-table-column prop="picid" label="picid" /> -->
        <el-table-column prop="status" label="状态" />
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status ==  0">正常</el-tag>
            <el-tag type="danger" v-else>异常</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="tags" label="告警标签" width="260" />
        <el-table-column prop="temp1" label="温度1" />
        <el-table-column prop="temp2" label="温度2" />
        <el-table-column prop="temp3" label="温度3" />
        <el-table-column prop="temp4" label="温度4" />
        <el-table-column prop="temp5" label="温度5" />
        <el-table-column prop="temp6" label="温度6" />
      </el-table>
      <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :total="total">
      </el-pagination>
    </el-dialog>
  </div>
</template>


<script>
  import request from "@/api/http.js";
  import {parseTime} from "@/utils";
  export default {
    data () {
      return {
        dialogVisible3: false,
        total: 0,
        tableData: [],//历史数据
        dialogVisible2: false,
        value2: '',
        value1: new Date(),
        radioed: 1,//时间类型
        temp: {},
        dialogVisible: false,
        list: [],
        pageX: 0,
        pageY: 0,
        flag: false,
        pageNum: 1,
        form: {},
        rules: {
          deviceAddress: [
            {required: true,message: '请输入地址',trigger: 'blur'}
          ],
        }
      }
    },
    computed: {
      getDataStyle () {
        return {
          'left': this.pageX+'px',
          'top': this.pageY+'px',
        }
      },
    },
    filters: {
      // 时间格式化
      parseTime (time,cFormat) {
        if(arguments.length===0) {
          return null
        }
        const format=cFormat||'{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if(typeof time==='object') {
          date=time
        } else {
          if((typeof time==='string')&&(/^[0-9]+$/.test(time))) {
            time=parseInt(time)
          }
          if((typeof time==='number')&&(time.toString().length===10)) {
            time=time*1000
          }
          date=new Date(time)
        }
        const formatObj={
          y: date.getFullYear(),
          m: date.getMonth()+1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str=format.replace(/{([ymdhisa])+}/g,(result,key) => {
          const value=formatObj[key]
          // Note: getDay() returns 0 on Sunday
          if(key==='a') {return ['日','一','二','三','四','五','六'][value]}
          return value.toString().padStart(2,'0')
        })
        return time_str
      },

    },
    mounted () {
      this.getList()
    },
    methods: {
      handleCurrentChange (val) {
        this.pageNum=val;
        this.search()
      },
      // 搜索
      search () {
        var params={
          deviceId: this.form.devid,
          endTime: '',
          pageNum: this.pageNum,
          pageSize: 10,
          startTime: '',
        }
        console.log(this.form,222);
        if(this.radioed==1) {
          var d=parseTime(this.value1,'{y}-{m}-{d}');
          params.startTime=new Date(d+' 00:00:00').getTime();
          params.endTime=new Date(d+' 23:59:59').getTime();
        } else {
          params.startTime=this.value2[0]
          params.endTime=this.value2[1]
        }
        console.log(params);
        request({url: "/thermometry/findThermometryDataNew",method: "get",params}).then(res => {
          if(res.code==200) {
            this.tableData=res.data.content;
            this.total=res.data.totalElements;
            this.dialogVisible3=true;
          }
        })
      },
      edit (v) {  //编辑弹窗
        this.temp=Object.assign({},v);
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },
      // 确认编辑
      edit_fn (formName) {
        console.log(this.temp);
        this.$refs[formName].validate((valid) => {
          if(valid) {
            var params={
              deviceAddress: this.temp.deviceAddress,
              deviceId: this.temp.devid
            }
            request({url: "/thermometry/update/address",method: "put",params}).then(res => {
              console.log(res,'res');
              if(res.code==200) {
                this.getList()
                this.$message({showClose: true,message: '修改成功',type: 'success'});
                this.dialogVisible=false;
              } else {
                res.message? this.$message.error(res.message):this.$message.error('修改失败');
              }
            })

          } else {
            return false;
          }
        });
      },

      detail (v,e) {
        this.pageX=v.pageX;
        this.pageY=v.pageY;
        this.form=e;
        console.log(this.getDataStyle,'aa');
        this.flag=true;

      },

      getList () {
        request({url: "/thermometry/findDeviceCurrentStatus",method: "get"}).then(res => {
          console.log(res,'res');
          if(res.code==200) {
            this.list=res.data
            this.list.map(v => {
              if(v.status===1) {
                // ",,"
                if(v.tags.indexOf('井盖异动')!=-1) {
                  v.gai=true;
                }
                if(v.tags.indexOf('低水位越限')!=-1) {
                  v.dishuiwei=true;
                }
                if(v.tags.indexOf('高水位越限')!=-1) {
                  v.gaoshuiwei=true;
                }
              }
            })
          }
        })
      }
    }
  }
</script>
<style scoped>
  .cableWell {
    background-color: #5798d1;
  }

  .laned {
    margin-top: 9px;
    height: 29px;
  }

  .red {
    background-color: #ed1b24 !important;
  }

  .btns {
    width: 100%;
    display: flex;
    justify-content: space-around;
    padding: 0 5px;
  }

  .btns .success {
    color: #2cdd71;
    cursor: pointer;
    font-size: 12px;
  }

  .form {
    position: fixed;
    padding: 10px;
    background-color: #fff;
    border: 1px solid #5a6a88;
    color: #5a6a88;
    font-size: 12px;
    display: flex;
    flex-direction: column;
  }

  .form .li {
    white-space: nowrap;
    overflow: hidden;
    margin-top: 2px;

  }

  .box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 20px;
    padding-bottom: 100px;
  }

  .box .li img {
    position: absolute;
    width: 27px;
    top: -25px;
    right: 0;
  }

  .box .li {
    position: relative;
    background-color: #7f7f7f;
    width: 8%;
    height: 186px;
    border-bottom: 5px solid #000;
    margin: 50px 1%;
  }

  .box .li .gai {
    background-color: #22af4d;
    border: 2px solid #000;
    height: 6px;
  }

  .box .li .huang {
    border: 4px solid #ece2b3;
    border-radius: 8px;
    margin: 5px;
    height: 163px;
    display: inline-block;
    width: 82%;
    background-color: #c3c3c3;
  }

  .box .li .huang .top {
    width: 100%;
    height: 52px;
    background-color: #7f7f7f;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    justify-content: end;
    margin-bottom: 29px;
  }

  .box .li .huang .lan {
    width: 100%;
    height: 4px;
    background-color: #079ee2;
    margin-top: 2px;
  }

  .box .li .huang .lv {
    width: 98%;
    height: 4px;
    background-color: #23b14d;
    border: 1px solid #000;
    margin: 0 auto;
    margin-bottom: 2px;
  }

  .box .li .huang .hong {
    width: 98%;
    height: 4px;
    background-color: #ed1b25;
    border: 1px solid #ed1b25;
    margin: 0 auto;
    margin-bottom: 2px;
  }
</style>